import classNames from "classnames";
import React from "react";
import styles from "./Ribbon-scss.js";
const Ribbon = ({ children, className }) => {
  return /* @__PURE__ */ React.createElement("div", { className: classNames(styles.ribbon, className) }, /* @__PURE__ */ React.createElement("span", { className: styles.ribbonText }, children));
};
export {
  Ribbon
};
//# sourceMappingURL=Ribbon.js.map
